import { AntDesign } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Modal, Pressable, Text } from "react-native";
import { CheckBox } from "react-native-btr";

import Warning from "@/assets/warning2.svg";
import Title from "@/components/Title";
import Button from "@/components/button/Button";

interface NonUsModalProps {
  visible: boolean;
  onClick?: (state: boolean) => void;
  onClose: () => void;
  hasChanged?: (state: boolean) => void;
  sendCode?: (code: string) => void;
  email?: string;
  password?: string;
}

export default function NonUsModal(props: NonUsModalProps) {
  const [check, setCheck] = useState(false);
  const { t } = useTranslation();

  function toggle() {
    if (check) return;
    setCheck(true);
    Cookies.set("nonUsModal", "true", { expires: 365 });
  }

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center justify-center shadow relative lg:w-104 lg:h-136 lg:justify-start">
          <Pressable className="absolute right-3 top-3" onPress={props.onClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <View className="flex-grow items-center justify-center lg:justify-start">
            <View className="m-2">
              <Title text={t("common:modal.nonus.title")} />
            </View>
            <View className="m-1">
              <Text className="text-lg text-darkergray text-center">
                {t("common:modal.nonus.content")}
              </Text>
            </View>
            <View className="w-full items-center p-4">
              <Warning width={140} height={100} />
            </View>
          </View>
          <Button
            label={t("common:button.understand")}
            onClick={() => props.onClose()}
          />
          <View className="flex-row gap-2 items-center">
            <CheckBox checked={check} onPress={toggle} color="#5D0CBA" />
            <Text className="text-base font-light">
              {t("common:modal.nonus.dontremindme")}
            </Text>
          </View>
        </View>
      </BlurView>
    </Modal>
  );
}
